import React, { Component, Suspense } from "react";
import { Loader } from "ui-kit-ck-consultant";

/**
 * Route host for the document editor (replaces the pilotage-cabinet-pdf-v2 PHP app).
 *
 *   /company-monitoring/document/:id  -> a suivi (pc2020_company_monitoring.cm_data)
 *   /company-monitoring/model/:id     -> a model  (pc2020_company_monitoring_document.cmd_data)
 *
 * The Suspense boundary has to live HERE, not on the route entry: App.js renders
 * `<route.component>` directly with no boundary of its own, so a bare React.lazy
 * used as a route component would throw at runtime. Lazy-loading is not optional
 * — the main bundle is already past CRA's size warning and Lexical adds ~90 kB
 * gzip, which this keeps in an on-demand chunk.
 */
const DocumentEditor = React.lazy(() =>
  import("../../../components/document/DocumentEditor")
);

export default class CompanyMonitoringDocument extends Component {
  handleClose = () => {
    // Opened in a new tab from the Suivi list; fall back to the list when the
    // tab was navigated to directly and window.close() is not allowed.
    window.close();
    this.props.history.push("/company-monitoring");
  };

  render() {
    const { match } = this.props;
    const id = match && match.params ? match.params.id : null;
    // Derived from the route itself rather than plumbed through App.js, which
    // forwards a fixed prop list to every page.
    const kind =
      match && match.path && match.path.indexOf("/model/") !== -1
        ? "model"
        : "document";

    return (
      <Suspense fallback={<Loader show={true} />}>
        <DocumentEditor id={id} kind={kind} onClose={this.handleClose} />
      </Suspense>
    );
  }
}
